import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptAube10 = () => {
  return (
    <DepartmentTemplate
      department="Aube"
      departmentNumber="10"
      cities="Troyes, Romilly-sur-Seine, La Chapelle-Saint-Luc"
      region="Grand Est"
    />
  );
};

export default DeptAube10;
